// A navigation that starts while the view transition of the previous one runs skips that transition, and Chromium
// reports the rejected `ready` of the skipped one as an uncaught error ("Transition was skipped"). TanStack Router
// awaits only `updateCallbackDone`, which still rejects when the update itself fails, so nobody handles `ready`: two
// filters changed in a row, or a click while a list loads, left an error in the console of every user and failed the
// browser tests at random on a busy machine (11/10).

type StartViewTransition = Document["startViewTransition"];

/** Marks the `ready` of every view transition as handled: a skipped animation is not a fault. Once per app. */
export function settleSkippedViewTransitions(doc: Pick<Document, "startViewTransition"> = document): void {
  if (typeof doc.startViewTransition !== "function") return;
  const start = doc.startViewTransition.bind(doc);
  doc.startViewTransition = ((update) => {
    const transition = start(update);
    transition.ready.catch(() => undefined);
    return transition;
  }) as StartViewTransition;
}
